const Home = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M197.39-140q-23.54 0-40.08-16.49t-16.54-40.05v-72.54L291.54-403v263h-94.15Zm131.07 0v-150.77h303.08V-140H328.46Zm340 0v-309.34L506.69-592.69l114.08-100.85 179.61 159.39q9.23 8.61 14.04 19.45 4.81 10.84 4.81 23.09v294.97q0 23.56-16.49 40.1Q786.25-140 762.69-140h-94.23ZM140.77-319.23v-172.12q0-12.23 4.81-23.52 4.81-11.28 14.04-19.28l282.69-250.62q8-7.61 17.75-10.92 9.75-3.31 19.96-3.31t19.94 3.31q9.73 3.31 17.73 10.92l75.39 67.16-452.31 398.38Z" />
        </svg>
    )
}

export default Home;

